import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GameSetupShell, { LevelStart, RunHeader, StatGrid, scoreTone, useGameStats } from '../../components/Games2/GameSetupShell';

const LEVELS = [
  { id: 1, name: 'Level 1', description: 'Practice Mode', rounds: 1, questionTime: 10, color: 'green', details: ['1 round, 20 pairs', '30 seconds to memorize', '10 seconds per question'] },
  { id: 2, name: 'Level 2', description: 'Training Mode', rounds: 2, questionTime: 10, color: 'yellow', details: ['2 rounds, 20 pairs each', '30 seconds to memorize', '10 seconds per question'] },
  { id: 3, name: 'Level 3', description: 'Real Test Mode', rounds: 2, questionTime: 7, color: 'rose', details: ['2 rounds, 20 pairs each', '30 seconds to memorize', '7 seconds per question'] },
];

const pct = (r) => parseFloat(r.total_percentage) || 0;

const roundStat = (run, n) => {
  const p = parseFloat(run[`round${n}_percentage`]) || 0;
  return { label: `Round ${n}`, value: `${run[`round${n}_correct`]}/${run[`round${n}_total`]}`, sub: `${p.toFixed(1)}%` };
};

const MEKSetup2 = () => {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const game = useGameStats('MEK', subjectId);
  const { stats } = game;
  const [level, setLevel] = useState(3);

  const start = () => {
    const l = LEVELS.find((x) => x.id === level);
    navigate(`/games/mek/${subjectId}/play`, { state: { subject: stats?.subject, level, rounds: l.rounds, questionTime: l.questionTime } });
  };

  return (
    <GameSetupShell
      code="MEK"
      name="Technical Comprehension"
      description="Visual memory assessment game"
      game={game}
      heroStats={[
        { label: 'Runs', value: stats?.total_runs || 0 },
        { label: 'Best', value: `${stats?.best_percentage || 0}%` },
        { label: 'Average', value: `${stats?.average_percentage || 0}%` },
      ]}
      picker={<LevelStart levels={LEVELS} value={level} onChange={setLevel} onStart={start} />}
      runs={stats?.history || []}
      chart={{ series: [{ label: 'Score', color: '#22C55E', value: pct, main: true }], max: 100, suffix: '%' }}
      renderRun={(run) => (
        <div className="space-y-4">
          <RunHeader run={run} level={run.level} score={<span className={scoreTone(pct(run))}>{pct(run).toFixed(1)}%</span>} scoreLabel={`${run.total_correct}/${run.total_questions} correct`} />
          <StatGrid cols="grid-cols-2" items={run.round2_total > 0 ? [roundStat(run, 1), roundStat(run, 2)] : [roundStat(run, 1)]} />
        </div>
      )}
    />
  );
};

export default MEKSetup2;
